// uses ES6
import UserBar from './UserBar';

jQuery.noConflict();
var Functions = (($, w) => { //shortcuts $=jQuery, w=window
  let _ = w._ = (...myVar) => console.log(...myVar);
  var APP = {
    init: () => {
      //start methods within APP
      _(`Avada:child's Theme - JS functions initiated`);
      UserBar.init();
    }
  };
  $(document).ready(() => {
    APP.init();
  });
})(jQuery, window, undefined);

module.exports = Functions;


// WEBPACK FOOTER //
// ./src/js/functions.js